import styles from './elaborate.module.css';
import * as React from 'react';
import {
    Button,
    Card,
    CardContent,
    CardFooter,
    CardHeader,
    Typography,
    Icons,
} from '@toppy-webshop/toppy-design-system';
import {
    ElaborateState,
    useSupportCaseStore,
} from '../../../store/supportCaseStore';
import {useState} from 'react';
import Dropzone from './Dropzone';

interface ElaborateProps {
    state: ElaborateState;
    questionOrderNumber: number;
    isQuestionaire?: boolean;
    cardsLayout?: boolean;
}

const Elaborate = ({
    state,
    questionOrderNumber,
    isQuestionaire = true,
    cardsLayout = false,
}: ElaborateProps) => {
    const submitElaboration = useSupportCaseStore(
        state => state.submitElaboration
    );
    const [isLoading, setIsLoading] = useState(false);
    const [description, setDescription] = useState<string>('');
    const [files, setFiles] = useState<File[]>([]);
    const allowNextStep =
        (!state.requireDescription || description.length > 0) &&
        (!state.requireUpload || files.length > 0);

    return (
        <Card shadow={cardsLayout ? undefined : 'none'} noMargin={!cardsLayout}>
            <CardHeader noHorizontalPadding={!cardsLayout}>
                <span className={styles.number}>{questionOrderNumber}</span>
                We hebben nog wat vragen
            </CardHeader>
            <CardContent>
                {state.requireDescription && (
                    <>
                        {state.descriptionDescription === null && (
                            <Typography weight={'bold'} gutterBottom>
                                Zou je nog even kort kunnen uitleggen wat er
                                precies aan de hand is?
                            </Typography>
                        )}
                        {state.descriptionDescription !== null && (
                            <Typography weight={'bold'} gutterBottom>
                                {state.descriptionDescription}
                            </Typography>
                        )}
                        <div>
                            <textarea
                                className={styles.text}
                                name={'problem-explanation'}
                                rows={4}
                                placeholder={'Het gaat over...'}
                                value={description}
                                onChange={e => setDescription(e.target.value)}
                            />
                        </div>
                    </>
                )}
                {state.requireUpload && (
                    <>
                        <Typography weight={'bold'} gutterBottom>
                            Zou je nog een of meerdere foto's willen toevoegen?
                        </Typography>
                        <br />
                        {state.uploadDescription === null && (
                            <Typography>
                                Probeer op de foto's zo goed mogelijk te laten
                                zien wat er aan de hand is. We gebruiken deze
                                foto's om de situatie te beoordelen en het helpt
                                ons om eventuele schade te verhalen bij de
                                transporteur.
                            </Typography>
                        )}
                        {state.uploadDescription !== null && (
                            <Typography>{state.uploadDescription}</Typography>
                        )}
                        <br />
                        <br />
                        <Dropzone onChange={files => setFiles(files)} />
                    </>
                )}
            </CardContent>
            <CardFooter noHorizontalPadding={!cardsLayout}>
                <Button
                    label={
                        allowNextStep
                            ? isQuestionaire
                                ? 'Volgende'
                                : 'Toevoegen'
                            : 'Vul alles in om verder te gaan'
                    }
                    rightIcon={isLoading ? Icons.LOADING : Icons.CH_RIGHT}
                    type={allowNextStep && !isLoading ? 'primary' : 'disabled'}
                    onClick={() => {
                        setIsLoading(true);
                        submitElaboration(
                            description === '' ? null : description,
                            files
                        ).then(() => {
                            setIsLoading(false);
                        });
                    }}
                />
            </CardFooter>
        </Card>
    );
};

export default Elaborate;
